module.exports = __webpack_public_path__ + "static/media/Quiche-Flare-Italic.97c7b776.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Quiche-Flare-Italic.ttf
// module id = 2202
// module chunks = 53